import React, { PropsWithChildren, useEffect } from 'react';
import { Button, ButtonProps } from '../buttons';
import styles from './Modal.scss';
import classNames from 'classnames';

export type ModalSize = '' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface ModalProps {
  id: string;
  title: string;
  open: boolean;
  onClose: () => any;
  onOpened?: () => any;
  size?: ModalSize;
  rightButtons?: ButtonProps[];
  leftButtons?: ButtonProps[];
  className?: string;
}

export const Modal: React.FC<PropsWithChildren<ModalProps>> = ({ id, title, open, onClose, children, ...props }) => {
  useEffect(() => {
    if (!open) {
      return;
    }

    const body = document.getElementsByTagName('body')[0];
    const bodyClass = body.className;
    body.className = classNames(bodyClass, 'modal-open');

    const backdrop = document.createElement('div');
    backdrop.className = 'modal-backdrop fade show';
    body.appendChild(backdrop);

    setTimeout(() => {
      props.onOpened && props.onOpened();
    }, 1);

    return function () {
      body.setAttribute('class', bodyClass);
      body.removeChild(backdrop);
    };
  }, [open]);

  return (
    <div
      className={classNames('modal fade', { show: open })}
      tabIndex={-1}
      role="dialog"
      style={open ? { paddingRight: '15px', display: 'block' } : { display: 'none' }}>
      <div className={classNames('modal-dialog', props.size && `modal-${props.size}`, props.className)} role="document" id={id}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">{children}</div>
          {props.leftButtons || props.rightButtons ? (
            <div className="modal-footer">
              {props.leftButtons &&
                props.leftButtons.map((r, i) =>
                  i == props.leftButtons!.length - 1 ? (
                    <Button key={i} {...r} className={classNames(styles['au-modal-button-push'], r.className)} />
                  ) : (
                    <Button key={i} {...r} />
                  ),
                )}
              {props.rightButtons && props.rightButtons.map((r, i) => <Button key={i} {...r} />)}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};
